import FishLogo from '@components/icons/FishLogo'
import { M58ForgotPasswordFormFragment } from '@lib/umbraco/generated/types.generated'
import { selectLabels } from '@redux/globalSlice'
import clsx from 'clsx'
import { useRouter } from 'next/router'
import { FC, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import ConfirmPage from '../M55SignupForm/ConfirmPage'
import s from './M58ForgotPasswordForm.module.scss'
import PasswordSendCodeStep from './PasswordSendCodeStep'
import SetPasswordStep from './SetPasswordStep'

type M58ForgotPasswordFormProps = {
  className?: string
} & M58ForgotPasswordFormFragment

export type StepData = {
  email: string
}

const M58ForgotPasswordForm: FC<M58ForgotPasswordFormProps> = ({
  ...props
}) => {
  const router = useRouter()
  const emailField = router.query?.email as string
  const labels = useSelector(selectLabels)

  const [step, setStep] = useState(1)
  const [data, setData] = useState<StepData | null>(null)

  const handleNext = (data: StepData) => {
    setData(data)
    setStep(2)
  }

  const { resetPasswordToken } = router.query as {
    resetPasswordToken: string
  }

  let email, token

  try {
    const decodedToken = atob(resetPasswordToken)
    ;[email, token] = decodedToken.split('|')

    if (!email || !token) {
      throw new Error('Decoded token format is invalid')
    }
  } catch (error) {
    console.log('Invalid or improperly formatted token:', error)
  }

  useMemo(() => {
    if (email && token) {
      return setStep(3)
    }
  }, [email, token])

  return (
    <div className={clsx('container', s.root)}>
      <div className={s.headline}>
        {step === 3 ? 'SET PASSWORD' : 'FORGOT PASSWORD'}
      </div>

      {step == 1 && (
        <PasswordSendCodeStep
          email={emailField}
          onNext={handleNext}
          {...props}
        />
      )}
      {step == 2 && (
        <ConfirmPage
          type={'ResetPassword'}
          email={data.email}
          text={labels.forgotPasswordText}
        />
      )}
      {step == 3 && <SetPasswordStep email={email} token={token} {...props} />}

      <FishLogo width={30} height={30} className="mx-auto" />
    </div>
  )
}

M58ForgotPasswordForm.displayName = 'M58ForgotPasswordForm'
export default M58ForgotPasswordForm
